import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import SessionListActionTypeEnum, {
  DUPLICATE_ANIMATION_DURATION,
  VISUAL_STATIC_DOCS,
} from './SessionListConstants';

const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);

export const selectDocumentSession = (docListItemId, documentType, documentName, key) => (
  (dispatch) => {
    dispatch({
      type: SessionListActionTypeEnum.DOCUMENT_SESSION_SELECT,
      docListItemId,
      documentType,
      documentName,
      key,
    });
  }
);

export const deselectDocumentSession = docListItemId => (
  (dispatch) => {
    dispatch({
      type: SessionListActionTypeEnum.DOCUMENT_SESSION_DESELECT,
      docListItemId,
    });
  }
);

export const deselectAllDocumentSessions = () => (
  (dispatch) => {
    dispatch({
      type: SessionListActionTypeEnum.DOCUMENT_SESSION_DESELECT_ALL,
    });
  }
);

export const addDocumentSessionList = sessionList => (
  (dispatch) => {
    dispatch({
      type: SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_ADD,
      sessionList,
    });
  }
);

export const duplicateDocumentSession = (
  documentType,
  docListItemHash,
  docListItemId,
  documentName,
  isContentExcluded = false,
) => (
  async (dispatch) => {
    try {
      const response = await formSwiftAPIClient.request(
        'POST',
        `/session/${docListItemId}/duplicate`,
        {
          user_id: window.COOKIE.get('userid'),
          user_token: window.COOKIE.get('userToken'),
          session_hash: docListItemHash,
          document_name: documentName,
          is_content_excluded: isContentExcluded,
        },
      );

      dispatch({
        type: SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_ITEM_ADD,
        item: {
          ...response.data.session,
          isVisualStatic: VISUAL_STATIC_DOCS.indexOf(documentType) !== -1,
          isDuplicate: true,
          isInSearchFilter: true,
        },
      });

      // Duration of duplicate document being animated. In order to allow
      // multiple animations without refreshing the page and reusing css,
      // we remove classes indicating that the document was duplicated
      setTimeout(() => {
        dispatch({
          type: SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_ITEM_UPDATE,
          idx: 0,
          updatedAttributes: {
            isDuplicate: false,
          },
        });
      }, DUPLICATE_ANIMATION_DURATION);

      return true;
    } catch (e) {
      dispatch({
        type: 'DOCUMENT_SESSION_LIST_ITEM_ADD_ERROR',
        error: e.message,
      });

      return false;
    }
  }
);

export const removeDocumentSession = docListItemId => (
  (dispatch) => {
    dispatch({
      type: SessionListActionTypeEnum.DOCUMENT_SESSION_REMOVE,
      docListItemId,
    });
  }
);

export const editDocumentName = (sessionId, documentName, documentNameKey) => (
  (dispatch) => {
    dispatch({
      type: SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_EDIT,
      sessionId,
      documentName,
      documentNameKey,
    });
  }
);

export const expandDocumentSession = expandKey => (
  (dispatch) => {
    dispatch({
      type: SessionListActionTypeEnum.DOCUMENT_SESSION_EXPAND,
      expandKey,
    });
  }
);

export const setSearchTerm = searchTerm => (
  (dispatch) => {
    dispatch({
      type: SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_SEARCH_TERM_SET,
      searchTerm,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/SessionList/SessionListActions.jsx